//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/qingxinvzhigong/banner.png'
import { getview } from '@/api/jfhl.js'
import config from '@/config/index'
export default {
  components: {},
  data () {
    return {
      partyid: this.$route.params.partyid,
      banner: banner,
      explist: [],
      baseUrl: config.baseUrl
    }
  },
  watch: {},
  computed: {
    bannerUrl () {
      return this.$store.state.lottery.bannerUrl
    }
  },
  mounted () {
    this.view()
  },
  methods: {
    // 获取问卷id
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        this.explist = res.obj.explist
      })
    }
  },
  created () { }
}
